<h2 mat-dialog-title> Entrada insumos de intervención </h2>
<mat-dialog-content class="mat-typography">
  <mat-card>
    <mat-card-title>
      <h4>{{ procedureObject[record.procedure] }}</h4>
      <div class="datetime-div">
        <span>{{formatDate(record.interventionDatetime)}}</span>
      </div>
    </mat-card-title>

    <div>

      <span><b>Folio:</b></span>
      <p>{{ record.fileNumber }}</p>

      <span><b>Episodio:</b></span>
      <p>{{ record.episode }}</p>

      <span><b>Especialidad:</b></span>
      <p>{{ record.specialty? specialtyObject[record.specialty] : "-" }}</p>

      <span><b>Doctor:</b></span>
      <p>{{record.doctor? doctorObject[record.doctor] : "-"}}</p>

      <span><b>Nombre del paciente:</b></span>
      <p>{{ record.patient ? patientObject[record.patient].name : "-"}}</p>

      <span><b>Sexo del paciente:</b></span>
      <p>{{ record.patient ? patientObject[record.patient].gender : "-"}}</p>
    </div>

    <!-- ✅ Tablas de materiales solicitados por categoría -->
    @if (categoryTables.length > 0) {
      @for (cat of categoryTables; track cat) {
        <mat-card style="margin-bottom: 16px;">
          <h4>Materiales solicitados — {{ cat.label }}</h4>
          <div class="table-container mat-elevation-z8">
            <table mat-table [dataSource]="cat.dataSource">
              <!-- itemCode Column -->
              <ng-container matColumnDef="itemCode">
                <th mat-header-cell *matHeaderCellDef> Código </th>
                <td mat-cell *matCellDef="let element"> {{element.itemCode}} </td>
              </ng-container>
              <!-- itemDescription Column -->
              <ng-container matColumnDef="itemDescription">
                <th mat-header-cell *matHeaderCellDef> Descripción </th>
                <td mat-cell *matCellDef="let element"> {{element.itemDescription}} </td>
              </ng-container>
              <!-- quantity Column -->
              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef> Cantidad Solicitada </th>
                <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
              </ng-container>
              <!-- delivery Column -->
              <ng-container matColumnDef="delivery">
                <th mat-header-cell *matHeaderCellDef> Entregado </th>
                <td mat-cell *matCellDef="let element"> {{element.delivery}} </td>
              </ng-container>
              <!-- type Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> Tipo Insumo </th>
                <td mat-cell *matCellDef="let element"> {{element.type}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="categoryColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: categoryColumns;"></tr>
            </table>
          </div>
        </mat-card>
      }
    } @else {
      <mat-card align="center">
        <p>No hay materiales solicitados para esta intervención.</p>
      </mat-card>
    }

    <!-- ✅ Fallback cuando no hay request -->

  </mat-card>

  <mat-card>
    <h4>Selección de insumos.</h4>
    <form [formGroup]="tagRfidForm">
      <!-- ✅ Selector de categoría -->
      <mat-form-field appearance="outline">
        <mat-label>Categoría</mat-label>
        <mat-select formControlName="category">
          @for (cat of categoryOptions; track cat) {
            <mat-option [value]="cat.key">
              {{ cat.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- Etiqueta RFID -->
      <mat-form-field appearance="outline">
        <mat-label>Etiqueta RFID (24 caracteres)</mat-label>
        <input matInput type="text" maxlength="24" placeholder="24 caracteres" formControlName="tagRfid"/>
        <mat-hint align="end">{{ (tagRfidForm.controls['tagRfid'].value || '').length }}/24</mat-hint>
        <mat-error>La etiqueta debe tener <strong>24 caracteres</strong></mat-error>
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="getItemByTagRfid()">Agregar</button>
    </form>
  </mat-card>

  @if (delivery.length==0) {
    <mat-card align="center">No hay insumos agregados.</mat-card>
  }

  @if (delivery.length>0) {
    <mat-card>
      <div class="consumption-container">
        <mat-list>
          <div mat-subheader>Insumos agregados</div>
          <div mat-subheader><b>Total: {{delivery.length}}</b></div>
          <mat-divider></mat-divider>
          @for (item of delivery; track item) {
            <mat-list-item>
              <mat-icon mat-list-icon>label</mat-icon>
              <div mat-line>{{item['codeName']}} | {{item['codeDescription']}}</div>
              <div mat-line> Etiqueta RFID: {{item['tagRfid']}} </div>
              <div mat-line> Lote: {{item['batch']}} </div>
              <div mat-line> Caducidad: {{item['expiration']}} </div>
              <div class="spacer"></div>
              <button mat-icon-button matTooltip="Eliminar insumo" color="warn" (click)="deleteItem(item)"><mat-icon>delete</mat-icon></button>
              <mat-divider></mat-divider>
            </mat-list-item>
          }
        </mat-list>
      </div>
    </mat-card>
  }

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button (click)="save()"> Guardar </button>
</mat-dialog-actions>